var UA = window.navigator.userAgent.toLowerCase()

function test(needle) {
  return needle.test(UA)
}

var IsHarmony = test(/openharmony/)
var IsAndroid = test(/android|htc/)
var IsIPad = !IsAndroid && test(/ipad/)
var IsIPhone = !IsAndroid && test(/ipod|iphone/)
var IsIPhoneX =
  /iphone/gi.test(navigator.userAgent) &&
  ((screen.height === 812 && screen.width === 375) ||
    (screen.width === 414 && screen.height === 896))
var IsIOS = IsIPad || IsIPhone
var IsWeixin = test(/micromessenger/)

var IsMiniprogram = test(/miniprogram/)

/**
 * isTitans: iOS 和 Android 的 KNB 容器标识
 * - UA 中包含 "titans" 或 "titansx"
 * - iOS 和 Android 的 KNB 能力相同
 */
var IsTitans = !IsMiniprogram && test(/titansx|titans/)

/**
 * isKNB: 所有 KNB 容器标识（iOS + Android + 鸿蒙）
 * - UA 中包含 "knb"
 * - 鸿蒙系统中只有 knb，没有 titans
 * - 用于判断是否在 KNB 容器中
 */
var IsKNB = !IsMiniprogram && test(/knb/)
var IsMeituan = !IsMiniprogram && test(/meituangroup|com.meituan.imeituan/)
var IsDianping = test(/com.dianping/)
var IsIOSDianping = IsIOS && IsDianping

var env = {
  isHarmony: IsHarmony, // 鸿蒙系统
  isAndroid: IsAndroid,
  isIPad: IsIPad,
  isIPhone: IsIPhone,
  isIPhoneX: IsIPhoneX,
  isIOS: IsIOS,
  isWeixin: IsWeixin,
  isTitans: IsTitans, // iOS、安卓KNB容器
  isKNB: IsKNB, // iOS、安卓KNB容器 && 鸿蒙KNB容器（鸿蒙KNB容器ua中不含titans）
  isMeituan: IsMeituan, // 美团主App
  isDianping: IsDianping, // 大众点评App
  isIOSDianping: IsIOSDianping, // iOS 下的点评 App（导航栏特殊适配）
  isMiniprogram: IsMiniprogram, // 小程序（所有）
}

var documentElement = window.document.documentElement
for (var i in env) {
  if (env[i]) {
    documentElement.className += ' ' + i.replace('Is', '').toLowerCase()
  }
}

export default env
